import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';

// 该组件目前完全走鲸海蓝
var getModalStyle = function getModalStyle(props) {
  var _getThemeData = getThemeData(props, 'modal'),
    titleFontSize = _getThemeData.titleFontSize,
    confirmIconSize = _getThemeData.confirmIconSize;
  return css([".c7n-pro-modal{.c7n-pro-modal-header{.c7n-pro-modal-title{font-size:", "px;}}.c7n-pro-modal-content{.c7n-pro-modal-body{.c7n-pro-confirm-icon .icon{font-size:", "px;}.c7n-pro-table-professional-query-bar-button{padding:0.1rem 0px 0.04rem 0.4rem;}.c7n-pro-table-professional-query-bar-button-vertical{padding:0.23rem 0 0.04rem 0.4rem;}}}&-drawer &-footer{text-align:right;}}"], titleFontSize, confirmIconSize);
};
var modalData = {
  name: 'modal',
  data: [{
    titleFontSize: 14,
    confirmIconSize: 24
  }],
  // 不使用主题5模板
  onlyTemplate: {
    pro: getModalStyle
  }
};
export default modalData;